import { useState, useEffect } from 'react';
import { units } from '@ui/css';
import { applyCssDeclarations } from '@utils/css';
import { tokens } from './toggle-group.style.js';

function useHighlightSelectedTab(ref, props) {
  const [initialized, setInitialized] = useState(false);
  useEffect(() => {
    const wrapper = ref.current;
    const selectedTab = props.selectedTabRef.current;
    if (!wrapper || !selectedTab) {
      return;
    }
    const handleUpdate = () => {
      applyCssDeclarations(tokens.__override({
        selectedTabOffsetLeft: units.px(selectedTab.offsetLeft),
        selectedTabWidth: units.px(selectedTab.clientWidth)
      }), wrapper);
    };
    handleUpdate();
    setInitialized(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedTabId]);
  return initialized;
}

export { useHighlightSelectedTab };
//# sourceMappingURL=hook.highlight-selected-tab.js.map
